export default __webpack_public_path__ + "static/media/warning--panda-crossing--g1.e2bdb7b5.png";